import React from "react";
export const Footer10DataSource = {
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2, always: false },
  block: {
    className: 'home-page khrs669ca7-editor_css',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 8,
        className: 'block',
        title: {
          className: 'logo',
          children:'logo'
      },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>
                          دسترسی مطمئن وآسان به کلاس آنلاین و سیستم مدیریت
                          آموزشی
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              name: 'content~khtbx5orvl',
              className: 'khtbxdesblc-editor_css',
              children: (
                <span>
                  <p>آدرس : تهران، خیابان مطهری، خیابان میرزای شیرازی، کوچه مقدم، پلاک ۱۵</p>
                </span>
              ),
            },
            {
              name: 'content~khtbx6n564',
              className: 'khtbxg4vkd-editor_css',
              children: (
                <span>
                  <p>تماس تلفنی (شنبه تا چهارشنبه ۸ تا ۱۸ - پنجشنبه ۸ تا ۱۴)</p>
                </span>
              ),
            },
            {
              name: 'content~khtbx82h4e',
              className: 'khtbybg4nbf-editor_css',
              children: (
                <span>
                  <p>+989129576148</p>
                </span>
              ),
            },
            {
              name: 'content~khtbyebrn4',
              className: 'khtbyif803-editor_css',
              children: (
                <span>
                  <p>info@madtalk.ir</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 5,
        className: 'block',
        title: {
          children: (
            <span>
              <p>محصولات</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: '#',
              children: (
                <span>
                  <p>مدرسه آنلاین</p>
                </span>
              ),
            },
            {
              name: 'link1',
              href: '#',
              children: (
                <span>
                  <span>
                    <p>مدرسه هوشمند</p>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 5,
        className: 'block',
        title: {
          children: (
            <span>
              <span>
                <span>
                  <p>صفحات</p>
                </span>
              </span>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '#',
              name: 'link0',
              children: (
                <span>
                  <p>درباره ما</p>
                </span>
              ),
            },
            {
              href: '#',
              name: 'link1',
              children: (
                <span>
                  <p>تماس باما</p>
                </span>
              ),
            },
            {
              href: '#',
              name: 'link2',
              children: (
                <span>
                  <p>قوانین و مقررات</p>
                </span>
              ),
            },
            {
              href: '#',
              name: 'link3',
              children: (
                <span>
                  <p>وبلاگ</p>
                </span>
              ),
            },
            {
              href: '#',
              name: 'link4',
              children: (
                <span>
                  <p>حریم خصوصی</p>
                </span>
              ),
            },
            {
              href: '#',
              name: 'link5',
              children: (
                <span>
                  <p>وضعیت سرور ها</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>
                <br />
              </p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              name: 'image~khtcf1r85zh',
              className: '',
              children:'namad',
            },
          ],
        },
      },
      {
        name: 'block~khtbpo65vz',
        xs: 24,
        md: 24,
        className: 'block khtbpur5ap-editor_css',
        title: {
          children: (
            <span>
              <p>
                <br />
              </p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              name: 'image~khtbuapdrql',
              className: 'khtbtrb53vj-editor_css',
              children: 'twitter',
            },
            {
              name: 'image~khtc5m10vkj',
              className: 'khtc5n58ebr-editor_css',
              children: 'instagram',
            },
            {
              name: 'image~khtc5rom7fd',
              className: 'khtc643ac5-editor_css',
              children: 'linkedin',
            },
            {
              name: 'image~khtc5roh7fd',
              className: 'khtc643acf5-editor_css',
              children: 'telegram',
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright khtbirf2hv9-editor_css',
    children: (
      <span>
        <p>
          کلیه حقوق این وبسایت متعلق به شرکت نویان فناور آریا می باشد | 1399
        </p>
      </span>
    ),
  },
};
